import { Component, Input, OnInit } from '@angular/core';
import { RQuestion } from '../../models/rquestion';

@Component({
  selector: 'app-radio-button-card',
  templateUrl: './radio-button-card.component.html',
  styleUrls: ['./radio-button-card.component.scss']
})

export class RadioButtonCardComponent implements OnInit {
  @Input() rquestion: RQuestion;
  isChecked: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
